import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { USERROUTES } from './url-constant';
import { useDispatch } from 'react-redux';
import { clearloggedEmployeeReducer } from '../../admin/hooks/redux/slice/logged-employee';
import { clearemployeeAccessTokenTokenReducer } from '../../admin/hooks/redux/slice/employee-access-token';

const UserAppLogOut = ({ children }) => {
    const navigation = useNavigate();
    const dispatch = useDispatch();
    const events = [
        "load",
        "mousemove",
        "mousedown",
        "click",
        "scroll",
        "keypress",
    ];
    let timer;

    // this function sets the timer that logs out the user after 10 secs
    const handleLogoutTimer = () => {
        timer = setTimeout(() => {
            resetTimer();
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer);
            });
            // logs out user
            logoutAction();
        }, 3600000); // 3600000 = 60secs. You can change the time.
    };

    // this resets the timer if it exists.
    const resetTimer = () => {
        if (timer) clearTimeout(timer);
    };

    // However, if none of the event is triggered within 10 secs, that is app is inactive, the app automatically logs out.
    useEffect(() => {
        Object.values(events).forEach((item) => {
            window.addEventListener(item, () => {
                resetTimer();
                handleLogoutTimer();
            });
        });
    }, []);

    // logs out user by clearing out auth token in localStorage and redirecting url to /signin page.
    const logoutAction = () => {
        dispatch(clearloggedEmployeeReducer())
        dispatch(clearemployeeAccessTokenTokenReducer())
        navigation(USERROUTES.USERLOGIN);
    };
    return children;
}

export default UserAppLogOut;
